import { motion } from 'framer-motion';
import { Handshake, ArrowUpRight } from 'lucide-react';

const PARTNERS = [
  {
    name: 'Daiya',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/n0l62wu7_Daiya-Logo-DairyFree-Colour-800x350.png',
    role: 'Plant-based cheese',
    url: 'https://daiyafoods.com/'
  },
  {
    name: 'Yoso',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/uft29he6_YOSO-Logo-BlackGreen_3b920c98-21df-4299-8b9b-686403a3eb94.webp',
    role: 'Organic plant-based dairy',
    url: 'https://yoso.ca/'
  },
  {
    name: 'TMRW',
    logo: 'https://customer-assets.emergentagent.com/job_vegan-danish-bakery/artifacts/504dbzo2_TMRW-grey.png',
    role: 'Plant-based meats',
    url: 'https://tmrwfoods.com/'
  }
];

export const Partners = () => {
  return (
    <section className="relative py-16 md:py-20">
      <div className="container mx-auto">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-4">
            <div className="font-script text-2xl text-leaf">ingredient partners</div>
            <h2 className="font-display text-3xl sm:text-4xl text-primary font-medium leading-tight mt-1">
              The brands<br/>
              <span className="italic font-light text-leaf">behind the brand.</span>
            </h2>
            <p className="text-muted-foreground mt-4 text-sm md:text-base max-w-sm">
              We collaborate with Canada's most-loved plant-based makers to deliver
              the melt, the texture and the flavor our customers expect.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary text-xs font-medium text-primary">
              <Handshake className="h-3.5 w-3.5 text-leaf" /> Proud Canadian partnerships
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-3 gap-4">
            {PARTNERS.map((p, i) => (
              <motion.a
                key={p.name}
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.08 }}
                className="group relative flex flex-col rounded-3xl bg-card border border-border/70 overflow-hidden shadow-soft hover:shadow-card hover:-translate-y-1 transition-all duration-500"
              >
                <div className="relative h-40 bg-secondary/50 grid place-items-center p-8 overflow-hidden">
                  <div className="absolute inset-0 bg-grain opacity-40 pointer-events-none" />
                  <img
                    src={p.logo}
                    alt={`${p.name} logo`}
                    className="relative max-h-20 max-w-[65%] object-contain group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 right-3 h-8 w-8 rounded-full bg-background/85 backdrop-blur grid place-items-center text-primary group-hover:bg-accent group-hover:text-accent-foreground transition-colors">
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </div>
                </div>
                <div className="p-5 flex items-center justify-between gap-3">
                  <div>
                    <div className="font-display text-lg font-semibold text-primary">{p.name}</div>
                    <div className="text-xs uppercase tracking-[0.16em] text-leaf font-medium mt-1">{p.role}</div>
                  </div>
                  <div className="text-xs text-muted-foreground group-hover:text-leaf transition-colors whitespace-nowrap">
                    Visit &rarr;
                  </div>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
